import { configManager } from 'utils/configuration';

type RaffleLandingModalConfig = {
  enabled: boolean;
  imageUrl: string;
  imageAlt: string;
  title: string;
  totalEstimatedPrize: number;
  prizeList: {
    name: string;
    quantity: number;
  }[];
};

type RaffleLandingModalConfigs = {
  landingModal: RaffleLandingModalConfig;
};

function getConfigs(): RaffleLandingModalConfigs {
  const getConfig = configManager.getInstance().get;

  const landingModalConfigs = (getConfig('RAFFLE') as RaffleLandingModalConfigs)
    .landingModal;

  return { landingModal: landingModalConfigs };
}

export default getConfigs;
